import { StackFrameMapper } from '../../../../../common/calls/mappers/StackFrameMapper';
import { RemediationMapper } from '../../../../../common/mappers/RemediationMapper';
import { SeverityMapper } from '../../../../../common/mappers/SeverityMapper';
import { GQLIdEncoder } from '../../../../../common/utils/GQLIdEncoder';
import { Instance } from '../models/Instance';

export class InstanceMapper {
  private readonly gqlIdEncoder = new GQLIdEncoder();
  private readonly remediationMapper = new RemediationMapper();
  private readonly stackFrameMapper = new StackFrameMapper();
  private readonly severityMapper = new SeverityMapper();

  mapGQLModel(data: any): Instance {
    let details: object | null = null;
    try {
      details = JSON.parse(data.details);
    } catch {
      // Do nothing
    }

    const remediation = this.remediationMapper.mapGQLModel(data.remediation);
    const specificTag = this.remediationMapper.mapSpecificTag(data.remediation);

    return new Instance(
      this.gqlIdEncoder.decode(data.id),
      this.gqlIdEncoder.decode(data.projectId),
      this.gqlIdEncoder.decode(data.reportId),
      data.traceType,
      data.numberLocal ?? 0,
      this.severityMapper.mapSeverity(data.severity),
      data.data,
      data.filterStatus,
      details,
      remediation,
      specificTag,
      Array.isArray(data.hardCodedStringLocations) && data.hardCodedStringLocations.length > 0
        ? data.hardCodedStringLocations.map((h: any, index: number) => this.stackFrameMapper.mapGQLModel(h, index))
        : null,
      data.rule.number,
      data.rule.shortExplanation,
      data.rule.title,
      data.jiraExportUrl,
      data.serviceNowExportUrl
    );
  }
}
